<template>
  <b-container fluid class="animated fadeIn">
    <div class="d-flex align-items-center">
      <b-col>
        <h1 class="app-title mt-4">
          Agenda de Prazos
        </h1>
      </b-col>
    </div>

    <b-card>
      <b-row>
        <b-col xs="6" sm="6" md="6" lg="6" xl="6">
          <b-form-group
            label="Procurador(a):"
            label-for="procurador"
            class="text-label"
          >
            <multiselect
              v-model="selected"  
              :show-labels="false"
              :options="listaProcuradores"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Selecione"
              track-by="id"
              label="nomeFormatado"
              :loading=isLoadingProcuradores
            >
              <template slot="noOptions" slot-scope="{ values, search, isOpen }">
                Lista vazia
              </template>
            </multiselect>
          </b-form-group>
        </b-col>
        <b-col xs="2" sm="2" md="2" lg="2" xl="2" class="d-flex flex-column mt-2">
          <b-button variant="primary" class="mt-4" @click="abrir()" :disabled="selected == null">
            <i class="fa fa-calendar"></i> Abrir Agenda
          </b-button>
        </b-col>
      </b-row>
      <hr />
      <div class="b-row">
        <b>Informações Importantes</b>
        <ul>
            <li>A visualização dos prazos no PROAJU não dispensa a conferência da agenda diretamente na interface do sistema Projudi. Sempre confira a sua agenda no Projudi</li>
            <li>Ao realizar o peticionamento no PROAJU, atualize a sua agenda de Prazos e verifique se o prazo de fato foi cumprido</li>
        </ul>
      </div>
    </b-card>

  </b-container>
</template>

<script>
import axios from 'axios'

const urlApi = process.env.VUE_APP_ROOT_API;

export default {
  components: {},
  data() {
    return {
      selected: null,
      listaProcuradores: [],
      isLoadingProcuradores: false
    };
  },
  mounted() {
    this.$store.commit('setAgendaProcurador', null);
    this.listarProcuradores();
  },
  methods: {
    abrir() {
      if (this.selected == null) {
        this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: ['Procurador deve ser informado!'] });
      } else {
        this.$store.commit('setAgendaProcurador', this.selected);
        this.$router.push("AgendaPrazos");  
      }
    },
    async listarProcuradores() {
      this.isLoadingProcuradores = true
      const token = JSON.parse(this.$store.getters.getUser).access_token;
      axios.get(`${urlApi}/v1/procurador/associados`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token
        }
      })
      .then((response) => {
        const data = response.data
        if (data.rows > 0) {
          this.listaProcuradores = data.resultado.map(self => ({
            name: self.nome,
            id: self.codProcurador,
            grupoTrabalho: self.grupoTrabalho ? self.grupoTrabalho.nome : null,
            nomeFormatado: self.nome + (self.grupoTrabalho ? " (" + self.grupoTrabalho.nome + ")" : ""),
            dataHoraUltimaSincronizacao: self.dataHoraUltimaSincronizacao
          }))
        }
        this.isLoadingProcuradores = false
      })
      .catch((error) => {
        this.isLoadingProcuradores = false
        error
      })
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.badge {
  font-size: 0.9rem;
}
</style>
